import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor } from '@atlaskit/primitives';
import { useAnalyticsEvents } from '../../common/analytics/generated/use-analytics-events';
import { CONTENT_URL_3P_ACCOUNT_AUTH, CONTENT_URL_SECURITY_AND_PERMISSIONS } from '../../constants';
import { messages } from '../../messages';
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */
var UnauthorisedViewContent = function UnauthorisedViewContent(_ref) {
  var providerName = _ref.providerName,
    isProductIntegrationSupported = _ref.isProductIntegrationSupported,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'unauthorised-view-content' : _ref$testId;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  var handleLearnMoreClick = useCallback(function () {
    fireEvent('ui.button.clicked.learnMore', {});
  }, [fireEvent]);
  var learnMoreMessage = isProductIntegrationSupported ? messages.learn_more_about_connecting_account : messages.learn_more_about_smart_links;
  return /*#__PURE__*/React.createElement(React.Fragment, null, providerName ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_unauthorised_account_description, {
    values: {
      context: providerName
    }
  })) : /*#__PURE__*/React.createElement(FormattedMessage, messages.connect_unauthorised_account_description_no_provider), ' ', fg('platform-linking-visual-refresh-v1') ? /*#__PURE__*/React.createElement(Anchor, {
    href: isProductIntegrationSupported ? CONTENT_URL_3P_ACCOUNT_AUTH : CONTENT_URL_SECURITY_AND_PERMISSIONS,
    target: "_blank",
    testId: "".concat(testId, "-learn-more"),
    onClick: handleLearnMoreClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, learnMoreMessage)) : /*#__PURE__*/React.createElement("a", {
    href: isProductIntegrationSupported ? CONTENT_URL_3P_ACCOUNT_AUTH : CONTENT_URL_SECURITY_AND_PERMISSIONS,
    target: "_blank",
    "data-testid": "".concat(testId, "-learn-more"),
    onClick: handleLearnMoreClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, learnMoreMessage)));
};
export default UnauthorisedViewContent;